export const getBase64 = (file: File, onlyData = true) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () =>
            resolve(
                onlyData
                    ? reader.result?.toString().split(';base64,')[1]
                    : reader.result
            );
        reader.onerror = (error) => reject(error);
    });
};
const getFileType = (type: string) => {
    if (type.toLocaleLowerCase() === 'pdf') return 'application/pdf';
    if (['png', 'jpg', 'jpeg', 'gif'].includes(type.toLowerCase()))
        return `image/${type.toLocaleLowerCase()}`;
    if (
        [
            'mp4',
            'mov',
            'avi',
            'wmv',
            'flv',
            'mkv',
            'mpeg',
            'mpg',
            'm4v',
            '3gp',
            '3g2',
            'webm',
            'ogg',
            'ogv',
        ].includes(type.toLowerCase())
    )
        return `video/${type.toLocaleLowerCase()}`;
    return 'application/octet-stream';
};

export const downloadFiles = async (
    items: { name: string; file: string }[]
) => {
    const newFiles = [];
    for (const item of items) {
        const response = await fetch(item.file);
        const blob = await response.blob();
        const file = new File([blob], item.name, {
            type: getFileType(item.name.split('.').pop() as string),
        });
        newFiles.push(file);
    }

    return newFiles;
};
